import { useLoadedData } from "../../../hooks/useLoadedData"
import { CRMSettings } from "../types"

export const useCRMSettingsData = (apiPath: string) => {
  const data = useLoadedData<CRMSettings>(`${apiPath}/settings`, { contact_attributes: [] });

  return {
    ...data,
  }
}

